import { Select } from 'antd'
import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import { TOPICS } from 'utils'

export default function useTopic(initialTopic?: string): [string, () => ReactNode] {
    const [topic, setTopic] = useState<string>(initialTopic || "math")

    useEffect(() => {
        if (initialTopic) {
            setTopic(initialTopic)
        }
    }, [initialTopic])


    let renderer: () => ReactNode = useCallback(
        () => {
            return <Select
                value={topic}
                style={{ width: 120 }}
                onChange={(value) => {
                    console.log(value)
                    setTopic(value)
                }}
                options={TOPICS.map(t => ({ ...t, value: t.topic }))}
            />
        },
        [topic, setTopic],
    )

    return [topic, renderer]
}